export const BASE_URL = process.env.REACT_APP_API_URL || "https://apiv1.lifechemistghana.com";
export const api_url = process.env.REACT_APP_API_URL || "https://apiv1.lifechemistghana.com";

export const endpoints = {
  login: "/authentication/login/",
};
